import React, { useState } from 'react';
import { ShoppingBag, X } from 'lucide-react';
import { HyroxProgramPopup } from '../../components/forms/HyroxProgramPopup';
import { CentrStickyPopup } from '../../components/CentrAffiliate';
import { BiminiAwarenessPopup } from '../../components/partners/BiminiAwarenessPopup';
import BloodTestPopup from '../../components/Articles/BloodTestPopup';
import { EchoOfferPopup } from '../../components/articles/EchoOfferPopup';

const HyroxStickyBar = ({ visible, onDismiss }) => (
  <div className={`sticky-cta-bar ${visible ? 'visible' : ''}`} data-testid="sticky-cta-bar">
    <span className="text-zinc-300 text-sm">
      <ShoppingBag className="w-4 h-4 inline mr-1 text-[#FFD100]" />
      <strong className="text-[#FFD100]">10% OFF</strong> HYROX Equipment with code <strong className="text-[#FFD100]">NINJA</strong>
    </span>
    <a
      href="https://tidd.ly/3X1dZZq"
      target="_blank"
      rel="sponsored noopener noreferrer"
      className="inline-block px-5 py-2.5 bg-[#FFD100] text-black font-bold text-xs uppercase tracking-wider no-underline hover:bg-[#ffe44d] transition-colors"
      style={{ fontFamily: 'Bebas Neue, sans-serif' }}
    >
      Shop Centr
    </a>
    <button onClick={onDismiss} className="text-zinc-500 hover:text-white transition-colors ml-2" aria-label="Close">
      <X className="w-4 h-4" />
    </button>
  </div>
);

const CentrFloatingTrigger = ({ onOpen }) => (
  <div className="fixed bottom-4 right-4 z-30">
    <button
      onClick={onOpen}
      className="bg-[#e8ff00] text-black px-4 py-2.5 text-xs uppercase tracking-wider shadow-lg hover:opacity-90 transition-opacity flex items-center gap-2"
      style={{ fontFamily: 'Bebas Neue, sans-serif' }}
      data-testid="centr-popup-trigger"
    >
      <ShoppingBag className="w-3.5 h-3.5" /> HYROX Gear — 10% Off
    </button>
  </div>
);

const isHyroxTagged = (article) =>
  article.category === 'HYROX' || (article.tags && article.tags.some((t) => ['hyrox'].includes(t.toLowerCase())));

export const ArticleFooterPopups = ({ article, slug, showPopup, stickyBar }) => {
  const [showCentrPopup, setShowCentrPopup] = useState(false);
  const isHyroxRelated = isHyroxTagged(article);

  return (
    <>
      {article.category === 'HYROX' && !stickyBar.closed && (
        <HyroxStickyBar visible={stickyBar.visible} onDismiss={stickyBar.dismiss} />
      )}

      {article.category === 'HYROX' && (
        <HyroxProgramPopup
          articleSlug={slug}
          forceShow={showPopup}
          disableAutoShow={slug === 'the-ultimate-guide-to-hyrox-training-plans-and-workouts-get-race-ready'}
        />
      )}

      {isHyroxRelated && (
        showCentrPopup
          ? <CentrStickyPopup onClose={() => setShowCentrPopup(false)} />
          : <CentrFloatingTrigger onOpen={() => setShowCentrPopup(true)} />
      )}

      {article.popup_config?.type === 'echo_offer' && <EchoOfferPopup />}

      {/* Bimini awareness popup replaces the generic newsletter popup (and the old
          $500 bimini_promo popup). Suppressed on HYROX/Peptides articles (their own
          popups own those surfaces), popup_config 'none', and — at trigger time —
          on pages with active lead magnets or another open modal. */}
      {article.category !== 'HYROX' && article.category !== 'Peptides' && !['echo_offer', 'none'].includes(article.popup_config?.type) && (
        <BiminiAwarenessPopup contextId={slug} />
      )}

      {slug === 'blood-tests-before-peptides-the-complete-pre-protocol-lab-guide' && (
        <BloodTestPopup articleSlug={slug} />
      )}
    </>
  );
};
